import React, { useEffect, useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { putMedicineRemarks } from "../../../connections/putMedicineRemarks";
import { useQuery } from "@tanstack/react-query";
import { getDoctor } from "../../../connections/getDoctor";

const UpdateMedicineRemarks = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  const medicineRemarksData = location.state || null;
  const handleChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const { data: getDoctorData, isLoading } = useQuery({
    queryKey: ["getDoctor", "all"],
    queryFn: () => getDoctor(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const allDoctorOptions = getDoctorData?.payload?.specialists || [];
  // Format options for react-select
  const formattedOptions = allDoctorOptions
    ?.filter((el) => el?.sp_type === "doctor")
    ?.map((test) => ({
      value: test.id,
      label: test.first_name + " " + test.last_name,
    }));
  const handleAddMedicineRemarks = async (e) => {
    e.preventDefault();
    const payload = {
      medicine_remark: formState,
    };
    if (!formState?.value) {
      toast.error("Value Required");
      return;
    }
    try {
      const data = await putMedicineRemarks(
        user?.token,
        payload,
        medicineRemarksData?.id
      );
      if (data.status.status === "SUCCESS") {
        toast.success("Medicine Remark Updated Successfully");
        setFormState({});
        navigate(-1);
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  useEffect(() => {
    if (medicineRemarksData) {
      setFormState((prev) => ({
        ...prev,
        doctor_id: medicineRemarksData?.doctor_id,
        value: medicineRemarksData?.value,
      }));
    }
  }, [medicineRemarksData]);
  return (
    <>
      <Header />
      <Sidebar activeClassName="medicine_remarks-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Medicine Remarks</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Medicine Remarks
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      {medicineRemarksData?.id}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Update Medicine Remarks</h4>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Doctor
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              isLoading={isLoading}
                              options={formattedOptions}
                              value={
                                formattedOptions.find(
                                  (option) =>
                                    option.value === formState?.doctor_id
                                ) || null
                              }
                              onChange={(e) =>
                                handleChange("doctor_id", e?.value)
                              }
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isSearchable
                              isClearable
                              placeholder="Choose Doctor"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Value <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.value}
                              name="value"
                              onChange={(e) =>
                                handleChange("value", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleAddMedicineRemarks}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default UpdateMedicineRemarks;
